import React from "react";
import AddNewCohort from "../../componentsGeneral/componentsSuperUser/addNewCohort/AddNewCohort";

const NewCohort = () => {
  return (
    <div>
      <AddNewCohort />
    </div>
  );
};

export default NewCohort;
